import React, { Component } from 'react';
import { Link, withRouter } from 'react-router-dom';

class NavLink extends Component {
  render() {
    const { staticContext, location, history, match, className = '', ...rest } = this.props;

    let isActive = location.pathname.indexOf(this.props.to) !== -1;
    let activeClass = isActive ? 'active' : '';
    let newClassNames = `${className} `.replace(/\s?active/ig, '') + ` ${activeClass}` ;

    return (
      <Link {...rest} className={ newClassNames} />
    );
  }
}

export default withRouter(NavLink);